import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { apporteurs as ap, eur, eur0, dfr } from './pilotageApi';

const COM_BADGE = { a_verser: 'bg-a', verse: 'bg-g', en_attente_cloture: 'bg-n', annulee: 'bg-r' };
const COM_LABEL = { a_verser: 'À verser', verse: 'Versée', en_attente_cloture: 'En attente clôture', annulee: 'Annulée' };

// Admin — Commissions (Lot 6). Groupé par partenaire ; versement virement + RIB copiable.
export default function Commissions() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [flash, setFlash] = useState(null);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState({});
  const [copied, setCopied] = useState(null);

  const say = (m) => { setFlash(m); setTimeout(() => setFlash(null), 3000); };

  const load = useCallback(() => {
    ap.commissions().then(setData)
      .catch((e) => { if (e.code === 401 || e.code === 403) nav('/connexion'); else setErr(e.message); });
  }, [nav]);
  useEffect(() => { load(); }, [load]);

  async function verser(p) {
    setBusy(true);
    try { const r = await ap.verser(p.partenaire.id, ''); say(`Versé : ${eur(r.montant_verse)} (${r.nb_dossiers} dossier(s)).`); load(); }
    catch (e) { say(`⚠️ ${e.detail || e.message}`); }
    finally { setBusy(false); }
  }

  function copyRib(iban, id) {
    if (!iban) return;
    navigator.clipboard?.writeText(iban);
    setCopied(id); setTimeout(() => setCopied(null), 2000);
  }

  if (err) return <div className="wrap"><div className="nt ba">{err}</div></div>;
  if (!data) return <div className="load" data-testid="commissions-loading">Chargement des commissions…</div>;

  return (
    <>
      <div className="top">
        <h1>Commissions</h1>
        <span className="ctx mono">{data.partenaires.length} partenaire{data.partenaires.length > 1 ? 's' : ''}</span>
        <div className="sp" />
      </div>
      <div className="wrap">
        {flash && <div className="nt ok" data-testid="flash">{flash}</div>}

        <div className="cts" data-testid="compteurs-commissions">
          <div className="ct al"><div className="v mono">{eur0(data.total_a_verser)}</div><div className="l">à verser (dossiers clôturés)</div></div>
        </div>

        {data.partenaires.length === 0 ? (
          <div className="empty">Aucun partenaire validé pour l'instant.</div>
        ) : data.partenaires.map((p) => {
          const isOpen = !!open[p.partenaire.id];
          const rib = p.partenaire.rib || {};
          return (
            <div className="bk" key={p.partenaire.id} data-testid={`commission-partenaire-${p.partenaire.id}`}>
              <div className="bh">
                <div className="gw">
                  <div className="t">{p.partenaire.raison_sociale || p.partenaire.email}</div>
                  <div className="m mono">
                    À verser <b style={{ color: 'var(--am)' }}>{eur(p.compteurs.a_verser)}</b> ·
                    Versé {eur(p.compteurs.verse)} · En attente {eur(p.compteurs.en_attente_cloture)}
                  </div>
                </div>
                <div className="sp" />
                {rib.iban && (
                  <button className="btn btn-s" data-testid={`copy-rib-${p.partenaire.id}`} onClick={() => copyRib(rib.iban, p.partenaire.id)}>
                    {copied === p.partenaire.id ? '✓ IBAN copié' : `IBAN ${rib.iban}`}
                  </button>
                )}
                <button className="btn btn-s btn-g" data-testid={`verser-${p.partenaire.id}`} disabled={busy || p.compteurs.a_verser <= 0}
                  onClick={() => verser(p)}>Marquer versé</button>
                <button className="btn btn-s" data-testid={`toggle-${p.partenaire.id}`}
                  onClick={() => setOpen({ ...open, [p.partenaire.id]: !isOpen })}>{isOpen ? 'Masquer' : 'Détails'}</button>
              </div>
              {isOpen && (
                <table>
                  <thead><tr><th>Dossier</th><th>Client</th><th>Montage</th><th>État</th><th className="nu">Total</th><th className="nu">Commission</th><th>Statut</th></tr></thead>
                  <tbody>
                    {p.dossiers.map((d) => (
                      <tr key={d.quote_id} data-testid={`com-dossier-${d.quote_id}`}>
                        <td className="mono">{d.numero}</td>
                        <td>{d.client_nom}</td>
                        <td>{d.montage === 'pour_lui' ? 'Pour lui' : 'Pour son client'}</td>
                        <td>{d.libelle}</td>
                        <td className="nu">{eur(d.total)}</td>
                        <td className="nu"><b>{eur(d.commission_montant)}</b></td>
                        <td><span className={`bg ${COM_BADGE[d.commission_statut] || 'bg-n'}`}>{COM_LABEL[d.commission_statut] || d.commission_statut}</span></td>
                      </tr>
                    ))}
                    {p.dossiers.length === 0 && <tr><td colSpan={7} className="empty">Aucun dossier apporté.</td></tr>}
                  </tbody>
                </table>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}
